import React from 'react';
import PropTypes from 'prop-types';
import { Curious } from '@curi/react';
import { gtmPageviewEvent } from '../../services/google-tag-manager';
import './NotFoundWrapper.css';

const imgURL = process.env.REACT_APP_CLOUDFRONT_URL;

class NotFound extends React.PureComponent {
    componentDidMount() {
      gtmPageviewEvent({
          pageName: 'codespark.com: 404 Error',
          componentProps: this.props,
      });
    }

    render() {
        return (
            <div className="not-found-page page">
                <h1 className="four0four-title">404</h1>
                <h3 className="four0four-subtitle">You found a Glitch!</h3>
                <div className="image-container">
                    <img className="four0four-image" src={`${imgURL}/global/404_glitch.png`} alt="" />
                </div>
                <p className="four0four-desc">This means you are looking for a page that doesn&rsquo;t exist.</p>
            </div>
        );
    }
}

NotFound.contextTypes = {
    mixpanel: PropTypes.object
};

export default props => (
    <Curious>
        {({ router, response, navigation }) => {
            return <NotFound router={ router } response={ response } { ...props } />;
        }}
    </Curious>
);



// WEBPACK FOOTER //
// ./src/containers/404/index.js